import { configureStore } from "@reduxjs/toolkit";
import componentsReducer from "../features/components/componentSlice";

export const store = configureStore({
  reducer: {
    components: componentsReducer,
  },
});
